<template>
  <div id="navbar">
    <div>
      <img src="../assets/image/banner1.jpg" alt="" v-if="active == 0" class="img">
      <img src="../assets/image/banner2.jpg" alt="" v-else class="img-small">
    </div>
    <div class="nav-list overflow">
      <div v-for="(item,index) in navList" :key="index" class="content_list fl overflow">
        <div class="fl title" @click="dealColor(index)">
          <router-link
            :to="{ path: item.path }"
            :class="index == active?'color':''"
            ref="link"
          >{{item.title}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      active: 0,
      navList: [
        {
          id: 1,
          title: "主页",
          path: "/home"
        },
        {
          id: 2,
          title: "实体店铺",
          path: "/shop"
        },
        {
          id: 3,
          title: "关于我们",
          path: "/aboutUs"
        },

        {
          id: 4,
          title: "旗下品牌",
          path: "/brand"
        },
        {
          id: 6,
          title: "人才计划",
          path: "/plan"
        },
        {
          id: 7,
          title: "联系信息",
          path: "/idea"
        },
        {
          id: 8,
          title: "有偿资讯",
          path: "/consult"
        },
      ]
    };
  },
  mounted() {
    this.navList.forEach((item,index) => {
      if(item.path == window.location.hash.substring(1)){
        this.active = index
      }
    })
    this.Bus.$on('showActive',(data) => {
      this.active = data
    })
  },
  methods: {
    dealColor(index) {
      this.active = index;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#navbar {
  width: 100%;
  height: 100%;
  position: relative;
  .img{
    width: 100%;
  }
  .img-small{
    width: 100%;
  }
  .nav-list {
    padding: 20px 30px;
    width: 63%;
    position: absolute;
    bottom: 0;
    left: 0px;
    padding-left: 70px;
    display: flex;
    // justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    background-color: #fff;
    border-top-right-radius: 24px ;

    .content_list {
      // padding: 0 25px;
      flex: 1;
      text-align: center;
      font-size: 14px;
      font-family: FZLTZHJW;
      border-right: 2px solid #000;
      // font-weight: 600;
      letter-spacing: 1px;

      &:last-child{
        border-right: none;
      }
      .title {
        a {
          text-decoration: none;
          color: #000;
        }

        .color {
          color: red;
        }
      }
    }

  }
}
</style>
